import { useSelector } from 'react-redux';
import { ContentWidth } from '__components/Layout/PageContentWidth';
import Cols from '__components/Layout/Cols';
import { APIKeys } from './APIKeys';
import { OAuth } from './OAuth';
import type { AccessStruct } from '@kizen/permissions/types';
import { PageCard, StyledSection } from '../styles';
import { getChosenBusiness } from 'store/authentication/selectors';

type TeamApiAccessProps = {
  access: {
    manageStandardApiKeys: AccessStruct;
    manageOauthAuthorizations: AccessStruct;
  };
};

export const TeamApiAccess = ({ access }: TeamApiAccessProps) => {
  const businessId = useSelector(getChosenBusiness)?.id;
  return (
    <StyledSection data-qa="manage-connections__team-api-access">
      <ContentWidth>
        <Cols columns={2} gutter="20px">
          {access.manageStandardApiKeys?.view ? (
            <PageCard data-qa="manage-connections__api-keys">
              <APIKeys
                businessId={businessId}
                access={access.manageStandardApiKeys}
              />
            </PageCard>
          ) : null}
          {access.manageOauthAuthorizations?.view ? (
            <PageCard data-qa="manage-connections__oauth">
              <OAuth access={access.manageOauthAuthorizations} />
            </PageCard>
          ) : null}
        </Cols>
      </ContentWidth>
    </StyledSection>
  );
};
